import { render, staticRenderFns } from "./MarketsStatus.vue?vue&type=template&id=651491f0&scoped=true"
import script from "./MarketsStatus.vue?vue&type=script&lang=js"
export * from "./MarketsStatus.vue?vue&type=script&lang=js"
import style0 from "./MarketsStatus.vue?vue&type=style&index=0&id=651491f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651491f0",
  null
  
)

export default component.exports